import {
  selectIsSoloRea,
  selectNativeAccessFeature,
  selectIsSoloInsuranceAgent
} from '../../../../store/selectors/customerProfile'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import AgentDropdown from '../AgentDropdown'
import { Logo } from '../../../../Components'
import { defineMessages, useIntl } from 'react-intl'
import { YourHomeDropdown } from './YourHomeDropdown'
import { useDispatch, useSelector } from 'react-redux'
import { useAppSelector } from '../../../../store/hooks'
import { RootState } from '../../../../types/rootState'
import { FindAHomeDropdown } from './FindAHomeDropdown'
import Header from '../../../../Components/shared/Header'
import { DesktopAuthButtons } from './DesktopAuthButtons'
import { Button, Icon } from '@homebotapp/hb-react-component-catalog'
import { selectClientIsGuest } from '../../../../store/selectors/client'
import publicLogo from '../../../../assets/publicHomSearch/HB-real-estate.png'
import { setIsShowingNativeAppCtaModal } from '../../../../store/slices/modals'

import styles from './DesktopHeader.module.scss'

export const MSG = defineMessages({
  alt: {
    id: 'DesktopHeader.publicSearch.logo.alt',
    defaultMessage: 'Homebot Real Estate Services'
  },
  getApp: {
    id: 'DesktopHeader.getApp',
    defaultMessage: 'Get App'
  }
})

export interface DesktopHeaderProps {
  enableAgentDropdown: boolean
  className?: string
}

export const DesktopHeader = ({ enableAgentDropdown, className }: DesktopHeaderProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isSoloRea = useSelector(selectIsSoloRea)
  const isGuest = useSelector(selectClientIsGuest)
  const isSoloInsuranceAgent = useSelector(selectIsSoloInsuranceAgent)
  const showFindAHomeDropdown = !isSoloRea && !isSoloInsuranceAgent
  const isPublic = useAppSelector(state => state.auth.isPublic)
  const hasNativeAccess = useSelector<RootState, boolean>(selectNativeAccessFeature)

  return (
    <Header className={classNames(styles.header, className)}>
      <Header.Content>
        {isPublic ? (
          <Link to='/home-search/public'>
            <img width={72} height={72} src={publicLogo} alt={intl.formatMessage(MSG.alt)} />
          </Link>
        ) : (
          <Logo className={styles.logo} />
        )}
        {!isPublic && (
          <>
            <div className={styles.navigation}>
              <div className={styles.tab}>
                <YourHomeDropdown />
              </div>
              {showFindAHomeDropdown && (
                <div className={styles.tab}>
                  <FindAHomeDropdown />
                </div>
              )}
            </div>
            <div className={styles.desktopActions}>
              {hasNativeAccess && !isGuest && (
                <Button
                  marginRight={1}
                  colorScheme='primary'
                  onClick={() => dispatch(setIsShowingNativeAppCtaModal(true))}
                  leftIcon={<Icon name='circle-arrow-down' width='5' height='5' />}
                >
                  {intl.formatMessage(MSG.getApp)}
                </Button>
              )}
              <DesktopAuthButtons />
              {enableAgentDropdown && <AgentDropdown />}
            </div>
          </>
        )}
      </Header.Content>
    </Header>
  )
}
